"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CENTRISTS_POLICY_4 = exports.CENTRISTS_POLICY_3 = exports.CENTRISTS_POLICY_2 = exports.CENTRISTS_DEFAULT_POLICY = exports.CENTRISTS_BONUS_2 = exports.CENTRISTS_BONUS_1 = exports.Centrists = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Resources_1 = require("../../Resources");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const SelectColony_1 = require("../../inputs/SelectColony");
const MarsCoalition_1 = require("../../cards/community/corporations/MarsCoalition");
const CentristsDefaultAction_1 = require("../../cards/turmoil/standardActions/CentristsDefaultAction");
const CentristsPolicy3Action_1 = require("../../cards/turmoil/standardActions/CentristsPolicy3Action");
class Centrists extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.CENTRISTS;
        this.description = 'Strives for equality and teamwork to achieve a greater good.';
        this.bonuses = [exports.CENTRISTS_BONUS_1, exports.CENTRISTS_BONUS_2];
        this.policies = [exports.CENTRISTS_DEFAULT_POLICY, exports.CENTRISTS_POLICY_2, exports.CENTRISTS_POLICY_3, exports.CENTRISTS_POLICY_4];
    }
}
exports.Centrists = Centrists;
class CentristsBonus01 {
    constructor() {
        this.id = 'cb01';
        this.isDefault = true;
        this.description = 'Gain 8 M€';
    }
    getScore(_player) {
        return 8;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player), { log: true });
        });
    }
}
class CentristsBonus02 {
    constructor() {
        this.id = 'cb02';
        this.description = 'Gain 1 TR';
        this.isDefault = false;
    }
    getScore(_player) {
        return 1;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.increaseTerraformRating();
        });
    }
}
class CentristsPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_DEFAULT_POLICY;
        this.description = 'Gain 6 M€';
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canUseSingleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        player.game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new CentristsDefaultAction_1.CentristsDefaultAction()));
        player.addResource(Resources_1.Resources.MEGACREDITS, 6, { log: true });
        MarsCoalition_1.MarsCoalition.handleSingleUsePolicyLogic(player, isDominantPartyAction);
        return undefined;
    }
}
class CentristsPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_2;
        this.description = 'Delegates cost 2 M€ more to place';
        this.isDefault = false;
    }
}
class CentristsPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_3;
        this.description = 'Trade with any colony tile for free';
        this.isDefault = false;
    }
    canAct(player, isDominantPartyAction = false) {
        if (player.game.gameOptions.coloniesExtension === false)
            return false;
        if (player.getFleetSize() === player.tradesThisGeneration)
            return false;
        const openColonies = player.game.colonies.filter((colony) => colony.isActive && colony.visitor === undefined);
        return openColonies.length > 0 && player.canUseSingleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new CentristsPolicy3Action_1.CentristsPolicy3Action()));
        const openColonies = player.game.colonies.filter((colony) => colony.isActive && colony.visitor === undefined);
        const coloniesModel = player.game.getColoniesModel(openColonies);
        game.defer(new DeferredAction_1.DeferredAction(player, () => new SelectColony_1.SelectColony('Select colony tile for trade', 'trade', coloniesModel, (colonyName) => {
            openColonies.forEach((colony) => {
                if (colony.name === colonyName) {
                    player.game.log('${0} traded with ${1}', (b) => b.player(player).colony(colony));
                    colony.trade(player);
                    return undefined;
                }
                return undefined;
            });
            return undefined;
        })));
        MarsCoalition_1.MarsCoalition.handleSingleUsePolicyLogic(player, isDominantPartyAction);
        return undefined;
    }
}
class CentristsPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4;
        this.description = 'When you play an Event card, you pay 2 M€ less for it';
        this.isDefault = false;
    }
}
exports.CENTRISTS_BONUS_1 = new CentristsBonus01();
exports.CENTRISTS_BONUS_2 = new CentristsBonus02();
exports.CENTRISTS_DEFAULT_POLICY = new CentristsPolicy01();
exports.CENTRISTS_POLICY_2 = new CentristsPolicy02();
exports.CENTRISTS_POLICY_3 = new CentristsPolicy03();
exports.CENTRISTS_POLICY_4 = new CentristsPolicy04();
//# sourceMappingURL=Centrists.js.map